import script from "./DataSafety.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSafety.vue?vue&type=script&setup=true&lang=js"

import "./DataSafety.vue?vue&type=style&index=0&id=35e3d0b4&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35e3d0b4"]])

export default __exports__